export const DAY_OF_MOTH_FROM = 15
export const DAY_OF_MOTH_TO = 26
export const DAY_OF_MOTH_INITIAL = 20

export const AMOUNT_INITIAL = 200000
export const TERM_INITIAL = 108
